import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import GetGatheringShareInfoDocument from "src/api/graphql/__generated__/documents/GetGatheringShareInfoDocument";
import GatheringPrivacy from "src/api/graphql/__generated__/enums/GatheringPrivacy";
import { SharePayloadProp } from "src/components/ShareMenu/types";
import { useGatheringStore } from "src/contexts/GatheringContext";
import useClientProfile from "src/hooks/useClientProfile";
import usePhotoDetailStore from "../stores/usePhotoDetailStore";

const usePhotoDetailShareLink = ({ tag }: { tag?: true } = {}) => {
	const gatheringId = useGatheringStore((state) => state.gatheringId);
	const { data } = useQuery(GetGatheringShareInfoDocument, {
		variables: {
			input: {
				gatheringId,
			},
		},
	});
	const { profile } = useClientProfile();
	const debouncedSettledPhoto = usePhotoDetailStore((state) => state.debouncedSettledPhoto);

	const linkShareProps = useMemo<SharePayloadProp | null>(() => {
		const gathering = data?.getGathering;
		if (!gathering) return null;
		if (!gathering.shareUrl) return null;
		if (!debouncedSettledPhoto?.photoId) return null;
		let url = `${gathering.shareUrl}/photo/${debouncedSettledPhoto.photoId}`;
		if (tag && profile?.refCode) {
			url = url + url.includes("?") ? `&tag=${profile.refCode}` : `?tag=${profile.refCode}`;
		}

		if (
			gathering?.privacy?.includes(GatheringPrivacy.PasswordRequired) &&
			gathering?.password
		) {
			return {
				data: [
					{
						type: "Text",
						text: `${url}\nCheck out this photo from ${gathering.name}!\n\nYour password is ${gathering.password}`,
					},
				],
			};
		} else {
			return {
				data: [
					{
						type: "Url",
						url: url,
					},
				],
			};
		}
	}, [data?.getGathering, debouncedSettledPhoto?.photoId, profile?.refCode, tag]);

	return { linkShareProps };
};
export default usePhotoDetailShareLink;
